<template>
  <div>
    <v-tooltip
      left
      bottom
      nudge-right="52"
      nudge-top="7"
      :open-on-click="false"
      :disabled="!folderTooltip"
      v-model="folderTooltip"
    >
      <template v-slot:activator="{ on }">
        <div
          v-if="isMobile()"
          class="folder-toggle "
          v-on="on"
          :class="{'icon-left': miniVariant, 'folder-icon-delay': $store.state.ui.folder.show}">
            <v-icon
              size="20"
              class="folder-trigger"
              color="white"
              @click="toggleDrawer">
              {{ $store.state.ui.folder.show ? 'mdi-close' : 'mdi-folder-open' }}
            </v-icon>
        </div>
      </template>
      <span>{{ !$store.getters['ui/folder'].show ? 'Open Folders' : 'Close Folders' }}</span>
    </v-tooltip>
    <v-navigation-drawer
      hide-overlay
      :mini-variant="miniVariant"
      :permanent="!miniVariant"
      :absolute="isMobile()"
      mini-variant-width="3"
      style="border-right:3px solid rgba(0,0,0,0.2);overflow:hidden"
      class="vertical-stretch"
    >
      <v-row
        v-if="form_visible"
        justify="center"
        class="ma-0"
        align="center"
      >
        <v-col cols="12 pb-0 mt-3">
          <v-text-field
            ref="folderName"
            v-model="fields.folder_name.value"
            outlined
            dense
            :rules="nameRules"
            label="New Folder Name"
            persistent-hint
            hint="36 characters maximum"
            @keydown.enter="create()"
          />
        </v-col>
        <v-col class="pr-0 ">
          <v-btn
            id="create-folder-btn"
            width="100%"
            class="text-capitalize custom-login"
            style="font-weight:500 !important"
            @click="create"
          >
            CREATE
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            width="100%"
            id="close-btn"
            outlined
            text
            color="grey darken-1"
            class="text-capitalize "
            style="font-weight:500 !important"
            @click="fields.folder_name.value = ''; form_visible = false"
          >
            Close
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="!form_visible"
        justify="center"
        align="center"
      >
        <v-col cols="10">
          <v-switch
            v-if="!isMobile()"
            v-model="$store.state.ui.folder.lock"
            dense
            hide-details
            color="mpBlue"
            label="Always Open"
            on
          />
          <v-btn
            id="new-folder-btn"
            outlined
            link
            width="100%"
            color="grey darken-3"
            class="text-capitalize mt-3"
            style="font-weight:500 !important"
            @click="form_visible = true"
          >
            <v-icon>mdi-plus</v-icon> New Folder
          </v-btn>
        </v-col>
      </v-row>
      <v-divider />
      <sl-vue-tree
        ref="folderTree"
        v-model="folders"
        @nodeclick="nodeClickHandler"
        @drop="dropHandler"
        @toggle="highlightSelected"
      >
        <template v-slot:sidebar="{node}">
          <v-icon
            v-if="loading_move"
            color="#03b6fc"
          >
            mdi-loading mdi-spin
          </v-icon>
          <v-btn
            v-if="node.data.id === fields.rename_folder.id"
            text
            link
            small
            class="pa-0"
            style="height:auto;min-width:auto;"
            :loading="fields.rename_folder.loading"
            @click="fields.rename_folder.id = 0"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-menu
            v-if="(node.data.owner_access || node.data.editor_access) && node.data.id && node.data.id !== fields.rename_folder.id && !$store.getters['ui/folder.externalElement'].id"
            :close-on-click="true"
            :disabled="!$store.state.ui.folder.show"
            :close-on-content-click="!isMobile() || node.data.owner_access"
            bottom
            left
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                link
                small
                class="pa-0"
                style="height:auto;min-width:auto; background-color: transparent !important;"
                v-on="on"
                @click.native.stop="nodeChildHandler(node)"
              >
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list
              class="pa-0"
              dense
              style="font-size:13px"
            >
              <v-tooltip
                right
                :open-on-click="isMobile()"
                :open-on-hover="!isMobile()"
                :disabled="node.data.owner_access"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-list-item
                      :disabled="!node.data.owner_access"
                      v-if="folder_type"
                      @click="dialog.show=true"
                    >
                      <v-icon
                        style="font-size:16px"
                        :color="!node.data.owner_access ? 'grey': ''"
                      >
                        mdi-account
                      </v-icon>&nbsp;Privacy
                    </v-list-item>
                  </div>
                </template>
                <span>Only folder owner can set the permissions for other users.</span>
              </v-tooltip>
              <v-tooltip
                right
                :disabled="node.data.owner_access || node.data.editor_access"
                :open-on-click="isMobile()"
                :open-on-hover="!isMobile()"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-list-item
                      :disabled="!node.data.owner_access && !node.data.editor_access"
                      @click="editHandler(node)"
                    >
                      <v-icon
                        style="font-size:16px"
                        :color="!node.data.owner_access ? 'grey': ''"
                      >
                        mdi-folder-edit
                      </v-icon>&nbsp;Rename
                    </v-list-item>
                  </div>
                </template>
                <span>Only the folder owner can rename the folder.</span>
              </v-tooltip>
              <v-divider />
              <v-tooltip
                right
                :disabled="node.data.owner_access"
                :open-on-click="isMobile()"
                :open-on-hover="!isMobile()"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-list-item
                      :disabled="!node.data.owner_access"
                      @click="delete_folder(node.data.id)"
                    >
                      <span :class="{'red--text': node.data.owner_access}"><v-icon
                        :color="node.data.owner_access ? 'red': 'grey'"
                        style="font-size:16px"
                      >mdi-delete</v-icon> Delete</span>
                    </v-list-item>
                  </div>
                </template>
                <span> Only the folder owner can delete the folder.</span>
              </v-tooltip>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:title="{node}">
          <span
            class="node-folder"
            @touchstart="folderHandler($event)"
            :class="{'hover-active': ($store.getters['ui/folder.externalElement'].id)}"
            @mouseover="expandParent(node)"
            @mouseup="moveItems(node)"
          >
            <span :class="{'isSelected': (node.data.id === folderId)}">
              <v-icon
                v-if="node.data.id === fields.move_folder.id"
                color="primary"
              >mdi-settings mdi-spin mdi-18px</v-icon>
              <v-icon
                v-else
                style="font-size:20px;"
                :class="{'grey--text text--lighten-2': (!node.isDraggable && node.data.id != null)}"
              >
                {{ node.children.length && node.isExpanded ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
              <span
                v-if="node.data.id !== fields.rename_folder.id"
                class="pl-1 node-data"
                :class="{'text-capitalize':node.data.id === null, 'grey--text text--lighten-1': (!node.isDraggable && node.data.id != null) }"
              >
                <v-tooltip
                  left
                  :disabled="($store.getters['ui/folder.externalElement'].id?true:false) || (!(!node.data.owner_access && node.data.editor_access))"
                  bottom
                  :open-on-click="false"
                  :open-on-hover="!isMobile()"
                  v-model="node.data.showInfo"
                  nudge-right="180"
                >
                  <template v-slot:activator="{on}">
                    <div
                      v-longPress
                      :data-node-id="node.data.id"
                      :data-node-title="node.title"
                      :data-show-info="node.data.showInfo"
                      :style="(node.data.id === fields.rename_folder.id)?'color:#03b6fc':''"
                      :class="{'hover-active': ($store.getters['ui/folder.externalElement'].id && (node.isDraggable && node.data.id == null))}"
                      v-on="on"
                    >
                     {{ node.title }}
                    </div>
                  </template>
                  <span class="tooltip-text">You can view and rename the folder, only owner can delete it </span>
                </v-tooltip>
              </span>
            </span>
          </span>
          <v-text-field
            v-if="node.data.id === fields.rename_folder.id"
            ref="newName"
            v-model="fields.rename_folder.value"
            :autofocus="node.data.id === fields.rename_folder.id"
            dense
            :rules="nameRules"
            label="New Name"
            class="d-inline-block pl-1"
            @keyup.enter="update"
          />
        </template>
        <template v-slot:draginfo>
          {{ drag_info }}
        </template>
        <template v-slot:toggle="{node}">
          <v-icon
            transition
            class="mr-1"
            @click="toggleHandler(node)"
            :style="(node.children.length ? '' : 'visibility:hidden')"
          >
            {{ node.isExpanded ? 'mdi-menu-down': 'mdi-menu-right' }}
          </v-icon>
        </template>
      </sl-vue-tree>
      <folder-privacy-modal :dialog="dialog" />
    </v-navigation-drawer>
  </div>
</template>

<script>
  import SlVueTree from 'sl-vue-tree'
  import { $folders } from '@/services'
  import FolderPrivacyModal from '@/components/FolderPrivacyModal'
  export default {
    components: {
      SlVueTree,
      FolderPrivacyModal,
    },
    directives: {
      longPress: {
        bind: function (el, binding, vNode) {
          let pressTimer = null
          let start = (e) => {
            if (e.type === 'click' && e.button !== 0) {
              return;
            }
            if (pressTimer === null) {
              pressTimer = setTimeout(() => {
                vNode.context.toggleTooltip(el.dataset.nodeId, true)
              }, 1000)
              e.returnValue = false
            }
          }
          let cancel = (e) => {
            if (pressTimer !== null) {
              clearTimeout(pressTimer)
              pressTimer = null
            }
          }
          let hide = (e) => {
            if (pressTimer !== null) {
              clearTimeout(pressTimer)
              pressTimer = null
            }
            if(!el.dataset.showInfo) {
              let item = { data: { id: el.dataset.nodeId }, title: el.dataset.nodeTitle }
              vNode.context.nodeClickHandler(item)
            } else {
              vNode.context.toggleTooltip(el.dataset.nodeId, false)
            }
          }
          el.addEventListener("touchstart", start)
          el.addEventListener("click", cancel)
          el.addEventListener("touchend", hide)
          el.addEventListener("touchcancel", cancel)
          el.$destroy = () => {
            el.removeEventListener('touchstart', start)
            el.removeEventListener("click", cancel)
            el.removeEventListener("touchend", hide)
            el.removeEventListener("touchcancel", cancel)
          }  
        },
        unbind: function (el, binding, vNode) {
          el.$destroy()
        }
      }
    },
    data () {
      return {
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 36) || "You've exceeded maximum character count",
        ],
        dialog: {
          show: false,
          timeDebounce: null,
          folder_id: null,
          owner_access: null,
          subfolder_checkbox: {
            owner: false,
            editor: false,
          },
          children: false,
        },
        ancestryNames: {},
        fields: {
          folder_name: {
            value: '',
          },
          rename_folder: {
            value: '',
            id: '',
            parent_id: '',
          },
          move_folder: {
            id: 'root',
          },
        },
        form_visible: false,
        drag_info: '',
        items: [],
        folders: [],
        expanded: [],
        selectedFolderId: null,
        loading_move: false,
        folder_type: undefined,
        flattenedNodes: [],
        unwatchAccountId:null,
        unwatchAccountId: null,
        unwatchFolderShow:null,
        folderTooltip: false
      }
    },
    computed: {
      folderId: {
        get () {
          return this.$store.state.folderId
        },
        set (newValue) {
          return this.$store.commit('setFolderId', newValue)
        },
      },
      miniVariant () {
        return !this.$store.state.ui.folder.show
      },
    },
    watch: {
      folderId () {
        if (this.folderId) {
          const selectedItem = this.items.filter(item => item.id === this.folderId)
          if(selectedItem.length>0 && selectedItem[0].ancestry)
          this.expandSelectedFolder(selectedItem[0].ancestry.split('/'), this.folders[0])
        }
        this.highlightSelected()
        this.selectedFolderId = this.folderId
      },
      $route (to, from) {
        this.fetch()
      },
      items () {
        this.folders = this.flattenNodes()
      },
      '$store.state.ui.folder.id' (){
        this.updateBreadCrums(this.$store.state.ui.folder.id)
      }
    },
    mounted () {
      this.fetch()
      this.unwatchFolderShow = this.$store.watch(
        state => state.ui.folder.show,
        (new_value, old_value) => {
          if (new_value === true) {
            this.$store.commit('ui/leftmenu', !this.$vuetify.breakpoint.smAndDown)
          }
        },
      )
      this.unwatchAccountId = this.$store.watch(
        state => state.ui.leftmenu,
        (new_value, old_value) => {
          if (new_value === false && this.$store.getters['ui/folder'].show) {
            this.$store.commit('ui/folder.show', false)
          }
        },
      )
      this.unwatchAccountId = this.$store.watch(
        state => state.auth.account.id,
        (new_value, old_value) => {
          this.fetch()
        },
      )
    },
    beforeDestroy () {
      this.unwatchAccountId()
      this.unwatchAccountId()
      this.unwatchFolderShow()
    },
    methods: {
      folderHandler (event) {
        event.returnValue = false
      },
      toggleTooltip(id, value) {
        //toggle tooltip based on type of element
        if(id === 'folder') {
          this.folderTooltip = value
        } else {
          const itemIndex = this.items.findIndex((obj => obj.id == id))
          if (itemIndex >= 0) {
            this.items[itemIndex].data.showInfo = value
            this.folders = this.flattenNodes()
          }
        }
      },
      isMobile () {
        return ["xs","sm"].includes(this.$vuetify.breakpoint.name)
      },
      toggleDrawer() {
        this.$store.commit('ui/folder.show')
        this.folderTooltip = false
      },
      expandSelected () {
        const selectedItem = this.items.filter(item => item.id === this.folderId)
        if (selectedItem.length > 0) {
          if (selectedItem[0].ancestry) {
            const items = selectedItem[0].ancestry.split('/').map(item => parseInt(item))
            this.expanded = [...items, ...this.expanded]
          }
        }
      },
      highlightSelected () {
        this.$nextTick(() => {
          /* Note: Removed the highlight if any left. */
          const selectedNode = document.getElementsByClassName('selected-node')
          if (selectedNode.length) {
            for (var i = 0; i < selectedNode.length; i++) {
              selectedNode[i].classList.remove('selected-node')
            }
          }
          /* Note: Highlight the selected folder.
                   If none is selected, select the root folder.
           */
          if (!this.folderId) {
            this.updateAncestry({})
            document.getElementsByClassName('sl-vue-tree-node-item')[0].classList
              .add('selected-node')
          } else {
            document.getElementsByClassName('isSelected')[0] && document.getElementsByClassName
              ('isSelected')[0].parentNode.parentNode.parentElement.classList.add('selected-node')
          }
        })
      },
      removeNode () {
        const $folderTree = this.$refs.folderTree
        const paths = $folderTree.getSelected().map(node => node.path)
        $folderTree.remove(paths)
      },
      expandParent (node) {
        if (this.$store.getters['ui/folder.externalElement'].id && node.children.length) {
          const mainFolder = 'My ' + this.$store.getters['ui/folder'].type + 's'
          if (!node.isExpanded && node.title != mainFolder) {
            node.isExpanded = true
            this.expanded.push(node.data.id)
          }
        }
      },
      expandSelectedFolder(ids,parent){
        let path = [0]
       for (let i = 0; i < ids.length; i++) {
          const index = parent.children.findIndex(item => item.data.id == ids[i])
          if (index != -1) {
            path.push(index)
           this.$refs.folderTree.updateNode(path, {isExpanded:true})
           const expandIndex = this.expanded.indexOf(parent.children[index].data.id)
              if (expandIndex === -1) {
                this.expanded.push(expandIndex)
              }
            parent = parent.children[index]
          }
        }
      },
      //handle the click of menu on folder and set values for dialog
      nodeChildHandler(item) {
        this.dialog.folder_id = item.data.id
        this.dialog.owner_access = item.data.owner_access
        this.dialog.children = !!item.children.length
      },
      nodeClickHandler (item) {
        this.drag_info = item.title
        this.selectedFolderId = item.data.id
        this.$store.commit('ui/folder.id', this.selectedFolderId)
        this.folderId = this.selectedFolderId
        const index = this.items.findIndex(node => node.id == item.data.id)
        this.updateAncestry({ ...this.items[index] })
        this.highlightSelected()
        if(this.isMobile()) {
          this.toggleTooltip(item.data.id, false)
          this.$store.commit('ui/folder.show', false)
        }
      },
      onExternalDropHandler (position, event) {
        this.fields.move_folder.id = position.node.data.id
        const externalElement = this.$store.getters['ui/folder.externalElement']
        this.move(externalElement.id, position.node.data.id, externalElement.type)
      },

      updateBreadCrums(folderId){
        const selectedItem = this.items.findIndex(item => item.id === folderId)
        if(selectedItem!== -1){
          this.updateAncestry({...this.items[selectedItem]})
        }
      },

      updateAncestry (items) {
        const ancesters = []
        if (items.ancestry) {
          const ancester_ids = items.ancestry.split('/')
          for (let i = 0; i < ancester_ids.length; i++) {
            const obj = {
              text: this.ancestryNames[ancester_ids[i]],
              id: ancester_ids[i],
            }
            ancesters.push(obj)
          }
        }
        items.id && ancesters.push({ text: items.name, id: items.id })
        this.$store.commit('ui/folder.ancestry', ancesters)
        this.drag_info = ancesters.length ? ancesters[ancesters.length - 1].text : '';
      },
      
      flattenNodes () {
        const items = this.items.filter(item => {
          if (item.ancestry !== null) return false
          const owner_access = item.is_owner
          const editor_access = item.is_editor
          item.isExpanded = (this.expanded.indexOf(item.id) > -1)
          item.title = item.name
          item.isSelectable = owner_access || editor_access
          item.isSelected = item.id === this.folderId
          item.isDraggable = owner_access || editor_access
          item.data = {
            id: item.id,
            parent_id: null,
            edit: false,
            owner_access: owner_access,
            editor_access: editor_access,
            ancestry: item.ancestry,
            showInfo: item.data && (item.data.hasOwnProperty("showInfo")? item.data.showInfo : false)
          }
          if (item.owner_access || item.editor_access) {
            item.children = this.traverse(item.id)
          }
          return item
        })
        return [
          {
            data: {
              id: null,
              parent_id: null,
              edit: false,
              showInfo: false
            },
            isDraggable: false,
            title: 'My ' + (this.$store.getters['ui/folder'].type
              ? this.$store.getters['ui/folder'].type.replace('_', ' ').replace('/', ' ') : '') + 's',
            children: items,
            isSelected: !this.folderId,
          },
        ]
      },

      traverse (ancestor) {
        this.ancestryNames = {}
        return this.items.filter(node => {
          this.ancestryNames[node.id] = node.name
          if (this.$store.getters['ui/folder'].id === node.id) {
            clearTimeout(this.timeDebounce)
            this.timeDebounce = setTimeout(() => {
              this.updateAncestry(node)
            }, 1000)
          }
          if (node.ancestry === null) {
            return false
          }
          const owner_access = node.is_owner
          const editor_access = node.is_editor
          let parent_id = null
          if (node.ancestry) {
            const temp = node.ancestry ? node.ancestry.split('/') : []
            parent_id = parseInt(temp[temp.length - 1])
          }
          if (parent_id === ancestor) {
            node.isExpanded = (this.expanded.indexOf(node.id) > -1)
            node.title = node.name
            node.isSelectable = owner_access || editor_access
            node.isSelected = node.id === this.folderId
            node.isDraggable = owner_access || editor_access
            node.data = {
              id: node.id,
              parent_id: parent_id,
              edit: false,
              owner_access: owner_access,
              editor_access: editor_access,
              ancestry: node.ancestry,
              showInfo: node.data && (node.data.hasOwnProperty("showInfo")? node.data.showInfo : false)
            }
            node.children = this.traverse(node.id)
            return node
          }
        })
      },
      toggleHandler (node) {
        const mainFolder = 'My ' + this.$store.getters['ui/folder'].type.replace('/', ' ').replace('_', ' ') + 's'
        if (node.title != mainFolder) {
          const index = this.expanded.indexOf(node.data.id)
          if (index > -1) {
            this.expanded.splice(index, 1)
          } else {
            this.expanded.push(node.data.id)
          }
        }
      },
      moveItems(node){
        if (this.$store.getters['ui/folder.externalElement'].id) {
          this.move(this.$store.getters['ui/folder.externalElement'].id, node.data.id || 'root', this.$store.getters['ui/folder.externalElement'].type)
        }
      },
      dropHandler (item, position) {
        const folder_id = item[0].data.id
        let parent_id = position.node.data.id
        if (position.placement !== 'inside') {
          parent_id = position.node.data.parent_id
        }
        this.move(folder_id, parent_id || 'root')
      },
      editHandler (node) {
        this.fields.rename_folder.id = node.data.id
        this.fields.rename_folder.parent_id = node.data.parent_id
        this.fields.rename_folder.value = node.title
        this.fields.rename_folder.loading = false
      },
      create () {
        if (!this.$refs.folderName.validate()) {
          return
        }
        const payload = {
          folder: {
            name: this.fields.folder_name.value,
            folder_type: this.folder_type,
          },
          parent_folder_id: this.selectedFolderId,
        }
        $folders.create(payload).then(response => {
          this.$store.commit('ui/snackbar', {
            message: 'Folder Created Successfully.',
            type: 'success',
          })
          this.form_visible = false
          this.fields.folder_name.value = ''
          this.fetch()
        }).catch(error => {
          console.error(error)
        })
      },
      update () {
        if (!this.$refs.newName.validate()) {
          return
        }
        this.fields.rename_folder.loading = true

        const payload = {
          folder: {
            name: this.fields.rename_folder.value,
            folder_type: this.folder_type,
          },
          parent_folder_id: this.fields.rename_folder.parent_id,
        }

        const folder_id = this.fields.rename_folder.id

        $folders.update(folder_id, payload).then(response => {
          this.$store.commit('ui/snackbar', {
            message: 'Folder Updated Successfully.',
            type: 'success',
          })
          this.fields.rename_folder.id = 0
          this.fields.rename_folder.parent_id = 0
          this.fields.rename_folder.value = ''
          this.fetch()
        }).catch(error => {
          console.error(error)
        }).finally(() => {
          this.fields.rename_folder.loading = false
        })
      },
      fetch () {
        /* No column of folder type in the old folders in image library
        so folder type should be empty */
        switch (this.$route.meta.folder_type) {
          case 'image' :
            this.folder_type = undefined
            break
          case 'contact_tag' :
            this.folder_type = 'tag'
            break
          case 'data_journey' :
            this.folder_type = 'data_workflow'
            break
          case 'sql_querie' :
            this.folder_type = 'relational_query'
            break
          case 'journey' :
            this.folder_type = 'workflow'
            break
          case 'acquisition_form' :
            this.folder_type = 'acquisition/builder'
            break
          case 'countdown_timer' :
            this.folder_type = 'live_content_image'
            break
          case 'signup_form' :
            this.folder_type = 'form'
            break
          case 'campaign_tag' :
            this.folder_type = 'ctag'
            break
          default :
            this.folder_type = this.$route.meta.folder_type
        }
        this.folderId = this.$store.getters['ui/folder'].id
        if (this.$route.meta.folder_type) {
          $folders.fetch({
            params: {
              folder_type: this.folder_type,
            },
          }).then(response => {
            this.items = response.data.data.folders
            this.$store.commit('ui/folder.length', this.items.length)
            this.expandSelected()
            this.highlightSelected()
          }).catch(error => {
            console.error(error)
          })
        }
      },
      move (element_ids, id, element_type) {
        switch(element_type) {
          case "countdown_timer" :
          element_type = "live_content_image"
          break
          case "campaign_tag" :
            element_type = "ctag"
          break
          case "relational_querie" :
            element_type = "relational_query"
          break
          case "data_journey" :
            element_type = "data_workflow"
          break
          case "journey" :
            element_type = "workflow"
          break
          case "contact_tag" :
            element_type = "tag"
          break  
          default : 
        }

        this.loading_move = true
        let dragged = false
        if (element_type == undefined) {
          element_type = 'folder'
        }
        else {
          dragged = true
        }

        const payload = {
          id,
          element_ids,
          element_type,
          folder_type: this.folder_type,
        }
        $folders.move(payload).then(response => {
          this.fetch()
          if (dragged) {
            this.$store.commit('ui/folder.externalElement', {
              id: null,
              type: null,
              refresh: true,
            })
            setTimeout(() => { // resetting refresh
              this.$store.commit('ui/folder.externalElement', {
                id: null,
                type: null,
                refresh: false,
              })
            }, 200)
          }
          this.fields.move_folder.id = 'root'
          this.loading_move = false
          this.items.map(item => {
            if (item.id == id) {
              this.$store.commit('ui/snackbar', { message: 'Added to folder ' + item.name + ' successfully', type: 'success' })
            }
          })
        }).catch(error => {
          console.error(error)
        })
      },
      delete_folder (folder_id) {
        $folders.delete(folder_id).then(response => {
          this.$store.commit('ui/snackbar', {
            message: 'Folder Deleted Successfully.',
            type: 'success',
          })
          this.removeNode()
          this.fetch()
        }).catch(error => {
          console.error(error)
        })
      },
    },
  }
</script>
<style scoped>
.custom-login {
  background-color: #4c5463 !important;
  color: #ffffff !important;
}
</style>
<style lang="scss">
.top64{
  top: 64px !important;
}
.sl-vue-tree , .sl-vue-tree *{
  font-family: inherit;
}
.sl-vue-tree .sl-vue-tree-node-item .sl-vue-tree-title{
  width:100%;
  display:flex
}
.sl-vue-tree .sl-vue-tree-node-item .sl-vue-tree-title .sl-vue-tree-toggle{
  margin-right: -7px;
}
.sl-vue-tree {
    position: relative;
    cursor: default;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    font-size:13px;
    cursor: pointer;
}
.sl-vue-tree .sl-vue-tree-node > .sl-vue-tree-node-item{
  padding:13px 7px 10px 2px;

}
.sl-vue-tree .sl-vue-tree-node-item{
  padding-left:5px;
}
.sl-vue-tree-root > .sl-vue-tree-nodes-list > .sl-vue-tree-node + .sl-vue-tree-node{
  border-top: 1px solid rgba(0,0,0,0.087);
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
    overflow: hidden;
    position: relative;
    padding-bottom: 4px;
}

/** Folder HighLight And Hover Effect Start **/
.sl-vue-tree .sl-vue-tree-node-item:hover {
  background-color: rgba(0,0,0,0.05);
}
.sl-vue-tree-selected > .sl-vue-tree-node-item:hover {
  .mdi-dots-horizontal::before{
    background-color: rgb(243, 243, 243) !important;
  }
}
/** Folder HighLight And Hover Effect End **/

.sl-vue-tree-node-list {
    position: relative;
    display: flex;
    flex-direction: row;
}

.sl-vue-tree-node-item {
    position: relative;
    display: flex;
    flex-direction: row;
}
.sl-vue-tree-gap {
    width: 20px;
    min-height: 1px;

}

.sl-vue-tree-sidebar {
    margin-left: auto;
}

.sl-vue-tree-cursor {
    position: absolute;
    height: 1px;
    width: 100%;
}

.sl-vue-tree-drag-info {
    position: absolute;
    background-color: rgba(255,255,255,0.8);
    margin-left: 10px;
    margin-bottom: 10px;
    padding: 3px 10px;
    color:black;
    border: 1px dashed #ccc;
    font-weight:500;
}

.sl-vue-tree-node-item .sl-vue-tree-sidebar{
  position: absolute;
  right:10px;
  transition: all 200ms;
  transform: translateX(150%);
  background: #f2f2f2;
}

.folder-rename-field{
  outline: none;
  border:none;
  border-bottom: 2px solid rgba(0,0,0,0.87);
}

.sl-vue-tree-node-item:hover .sl-vue-tree-sidebar,.sl-vue-tree-node.sl-vue-tree-selected > .sl-vue-tree-node-item .sl-vue-tree-sidebar {
 transform: translateX(0%);
}

@media screen and (max-width : 960px){
  .sl-vue-tree-node-item .sl-vue-tree-sidebar{
    transform: translateX(0%) !important;
  }
}

.folder-toggle {
  position:absolute;
  left: 255px;
  &.icon-left {
    left: 0
  }
}

.folder-icon-delay {
  transition-duration: 0.26s;
  transition-property: left;
}

.node-folder {
  width: 80%
}
</style>
<style lang="scss">
.hover-active{
  width:100%;
  &:hover{
    color: #03b6fc !important;
    .v-icon{
    color:#03b6fc
   }
  }
}
.selected-node{
  background-color: rgb(220,220,220);
  .mdi-dots-horizontal::before{
    background-color: rgb(220,220,220) !important;
  }
}
.node-data{
  word-break:break-word;
  margin-right: 35px !important;
}
.sl-vue-tree .sl-vue-tree-node-item .sl-vue-tree-title span span{
  display: flex;
  align-items: flex-start;
}

</style>
